module.exports = __webpack_public_path__ + "img/2.e2f27b87.png";